// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/checkbox-empty.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/checkbox-checked.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/checkbox-empty-disabled.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";

.filter {
    margin: 32px 0;
    background-color: #ffffff;
}

.filter__block {
    margin-bottom: 8px;
}

.filter__title {
    padding: 4px 8px;
    font-size: 16px;
    line-height: 22px;
    color: var(--color-granite);
    font-weight: bold;
}

.filter__clear {
    color: var(--color-granite);
    cursor: pointer;
    text-align: center;
    text-decoration: underline;
    margin-bottom: 20px;
    display: block;
}

.filter__list {
    max-height: 200px;
    overflow-y: auto;
    border: 1px solid #e0e0e0;
    padding: 10px
}

.filter__item {
    display: flex;
    flex-direction: row;
    align-items: center;
    overflow: hidden;
    padding: 5px 5px;
}

.filter__item-name {
    font-size: 14px;
    line-height: 22px;
    color: var(--color-granite);
    display: block;
    white-space: nowrap;
}


.filter__item > .checkbox {
    display: none;
}

.filter__item > .checkbox + div.filter__item-name {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
}

.filter__item > .checkbox + .filter__item-name:before {
    width: 1em;
    height: 1em;
    content: '';
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    margin-right: 10px;
    display: inline-block;
}

.filter__item > .checkbox:checked + div.filter__item-name {
    font-weight: bold;
}

.filter__item > .checkbox:checked + div.filter__item-name:before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.filter__item > .checkbox:disabled + div.filter__item-name {
    font-weight: normal;
    color: var(--color-light-periwinkle-crayola);
}

.filter__item > .checkbox:disabled + .filter__item-name:before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@media screen and (max-width: 1024px) {
    .filter {
        margin: 0;
    }

    .filter__list {
        max-height: none;
        border: 0;
        border-bottom: 1px solid var(--color-granite);
    }

    .filter__list :last-child {
        border: 0;
    }

    .filter__item {
        display: inline-block;
    }

    .filter__item > div.filter__item-name {
        padding: 3px 10px;
        border-radius: 5px;
        background-color: var(--color-light-periwinkle-crayola);
        max-width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .filter__item > .checkbox + .filter__item-name:before {
        display: none;
    }

    .filter__item > .checkbox:checked + div.filter__item-name {
        color: var(--color-white);
        background-color: var(--color-granite);
        font-weight: normal;
    }

    .filter__item > .checkbox:disabled + div.filter__item-name {
        font-weight: normal;
        background-color: var(--color-light-periwinkle-crayola);
        color: var(--color-pale-blue);
    }
}
`, "",{"version":3,"sources":["webpack://./resources/assets/site/css/filter.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,0BAA0B;IAC1B,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,cAAc;IACd,mBAAmB;AACvB;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,WAAW;IACX,yDAAgD;IAChD,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yDAAkD;AACtD;;AAEA;IACI,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI;QACI,SAAS;IACb;;IAEA;QACI,gBAAgB;QAChB,SAAS;QACT,6CAA6C;IACjD;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,uDAAuD;QACvD,eAAe;QACf,mBAAmB;QACnB,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,yBAAyB;QACzB,sCAAsC;QACtC,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,uDAAuD;QACvD,6BAA6B;IACjC;AACJ","sourcesContent":["@charset \"UTF-8\";\n\n.filter {\n    margin: 32px 0;\n    background-color: #ffffff;\n}\n\n.filter__block {\n    margin-bottom: 8px;\n}\n\n.filter__title {\n    padding: 4px 8px;\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-granite);\n    font-weight: bold;\n}\n\n.filter__clear {\n    color: var(--color-granite);\n    cursor: pointer;\n    text-align: center;\n    text-decoration: underline;\n    margin-bottom: 20px;\n    display: block;\n}\n\n.filter__list {\n    max-height: 200px;\n    overflow-y: auto;\n    border: 1px solid #e0e0e0;\n    padding: 10px\n}\n\n.filter__item {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    overflow: hidden;\n    padding: 5px 5px;\n}\n\n.filter__item-name {\n    font-size: 14px;\n    line-height: 22px;\n    color: var(--color-granite);\n    display: block;\n    white-space: nowrap;\n}\n\n\n.filter__item > .checkbox {\n    display: none;\n}\n\n.filter__item > .checkbox + div.filter__item-name {\n    display: flex;\n    flex-direction: row;\n    justify-content: start;\n    align-items: center;\n}\n\n.filter__item > .checkbox + .filter__item-name:before {\n    width: 1em;\n    height: 1em;\n    content: '';\n    background-image: url(../img/checkbox-empty.svg);\n    background-size: cover;\n    margin-right: 10px;\n    display: inline-block;\n}\n\n.filter__item > .checkbox:checked + div.filter__item-name {\n    font-weight: bold;\n}\n\n.filter__item > .checkbox:checked + div.filter__item-name:before {\n    background-image: url(../img/checkbox-checked.svg);\n}\n\n.filter__item > .checkbox:disabled + div.filter__item-name {\n    font-weight: normal;\n    color: var(--color-light-periwinkle-crayola);\n}\n\n.filter__item > .checkbox:disabled + .filter__item-name:before {\n    background-image: url(../img/checkbox-empty-disabled.svg);\n}\n\n@media screen and (max-width: 1024px) {\n    .filter {\n        margin: 0;\n    }\n\n    .filter__list {\n        max-height: none;\n        border: 0;\n        border-bottom: 1px solid var(--color-granite);\n    }\n\n    .filter__list :last-child {\n        border: 0;\n    }\n\n    .filter__item {\n        display: inline-block;\n    }\n\n    .filter__item > div.filter__item-name {\n        padding: 3px 10px;\n        border-radius: 5px;\n        background-color: var(--color-light-periwinkle-crayola);\n        max-width: 100%;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    .filter__item > .checkbox + .filter__item-name:before {\n        display: none;\n    }\n\n    .filter__item > .checkbox:checked + div.filter__item-name {\n        color: var(--color-white);\n        background-color: var(--color-granite);\n        font-weight: normal;\n    }\n\n    .filter__item > .checkbox:disabled + div.filter__item-name {\n        font-weight: normal;\n        background-color: var(--color-light-periwinkle-crayola);\n        color: var(--color-pale-blue);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
